export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID da loja: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Nome de utilizador: ',
      placeholder: 'Nome de utilizador para autenticação entre a sua loja e o WinOrder',
      validation: {
        required: 'O nome de utilizador não pode estar vazio',
        min: 'O comprimento mínimo do nome de utilizador é 3 caracteres',
      },
    },
    password: {
      label: 'Palavra-passe: ',
      placeholder: 'Palavra-passe para autenticação entre a sua loja e o WinOrder',
      validation: {
        required: 'A palavra-passe não pode estar vazia',
        complexity: 'A palavra-passe deve ter pelo menos 8 caracteres e conter pelo menos uma letra',
      },
    },
  },
  labels: {
    credentials: 'Credenciais:',
  },
  instructions: {
    title: 'Instruções de configuração:',
    step_1: 'Abra «Definições» → «Definições do programa» no WinOrder.',
    step_2: 'Mesmo no topo encontrará o botão «Configuração da loja online».',
    step_3:
      'Na janela seguinte encontrará todas as lojas pré-configuradas no WinOrder. Selecione «FoodAmigos» e clique em «Seguinte».',
    step_4:
      'Na janela seguinte, substitua <0>{{storeid_placeholder}}</0> por <1>{{company_id}}</1> no campo «URL do serviço web». <br />O resultado final deverá ter este aspeto: <2>{{url}}</2>',
    step_5: 'Na mesma janela, introduza <ClickToCopy>{{username}}</ClickToCopy> no campo «Nome de utilizador».',
    step_6:
      'Na mesma janela, introduza <ClickToCopy>{{password}}</ClickToCopy> no campo «Palavra-passe». Depois clique no botão «Seguinte».',
    step_7:
      'O WinOrder testa agora a ligação à interface do FoodAmigos. Clique em «Seguinte» e na janela seguinte em «Concluir».',
    step_8: 'Guarde as definições.',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  toasts: {
    error: 'Falha ao guardar as alterações',
    success: 'Alterações guardadas',
  },
};
